import { isEqual } from 'lodash';
import expandedTimeplanUnits from '../../../entities/TimeplanUnit/expandedTimeplanUnits';

export default function findDuplicates(timeplanUnits) {
  const expandedTimeplanUnitsSet = expandedTimeplanUnits(timeplanUnits, true);
  return expandedTimeplanUnitsSet
    .reduce((duplicates, timeplanUnit) => {
      const foundDuplicates = expandedTimeplanUnitsSet.filter((matchingTimeplanUnit) => {
        // TODO: Should be identifier?
        if (isEqual(timeplanUnit, matchingTimeplanUnit)) {
          return false;
        }

        const sameDate = timeplanUnit.date === matchingTimeplanUnit.date;
        const sameWorkType = timeplanUnit.workType === matchingTimeplanUnit.workType;
        const sameFrom = timeplanUnit.from === matchingTimeplanUnit.from;
        const sameTo = timeplanUnit.to === matchingTimeplanUnit.to;
        const sameResource = timeplanUnit.resourceId === matchingTimeplanUnit.resourceId;

        return sameDate && sameWorkType && sameFrom && sameTo && sameResource;
      });

      if (foundDuplicates.length > 0) {
        const id = timeplanUnit.sourceId || timeplanUnit.id;
        return {
          ...duplicates,
          [id]: foundDuplicates,
        };
      }

      return duplicates;
    }, {});
}
